import * as Yup from "yup";

export const tvSchema = Yup.object().shape({
  tv_name: Yup.string().required("TV Name is required"),
  gym_id: Yup.string().required("gym is required"),
  tv_user_id: Yup.string().required("user is required"),
});
